var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.563,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b55ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ddee7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48284",
    "data-name": "Group 48284",
    transform: "translate(-874 -1364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24109",
    "data-name": "Rectangle 24109",
    width: 25,
    height: 16,
    rx: 3,
    transform: "translate(874 1364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "OTHER",
    transform: "translate(876 1374)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Modern-Regular, 'Modern No\\\\\\\\. \\\\\\\\32 0'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OTHER")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.9bdce9a1cc8476e77d028dfb53b1da4e.svg";
export { ForwardRef as ReactComponent };